export default __webpack_public_path__ + "static/media/close.b2aa9292.svg";